import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=df879f32&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=df879f32&prod&lang=scss&scoped=true"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=df879f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df879f32",
  null
  
)

export default component.exports